import { Flex, Img, Text } from "@chakra-ui/react";
import maquininha from "../../../assets/images/maquininha-monedd.png";

export default function Simulator({ setIsOpen }: any) {
  // Tudo em clamp: as medidas em vw sumiam num 4:3 de 1024 e viravam um
  // banner gigante num ultrawide. A sobreposição da maquininha sobre a
  // tarja azul é proporcional à própria tarja, por isso o mr negativo em clamp.
  return (
    <Flex justifyContent={"center"} alignItems={"center"} maxW={"100%"}>
      <Flex
        h={"clamp(84px, 7vw, 120px)"}
        w={"clamp(120px, 8vw, 160px)"}
        mr={"clamp(-28px, -1.5vw, -18px)"}
        bgColor={"#1C3E92"}
        alignItems={"center"}
        justifyContent={"flex-start"}
        pl={"clamp(16px, 1.8vw, 35px)"}
        borderRadius={"20px 0 0 20px"}
        onClick={() => setIsOpen(true)}
        _hover={{ cursor: "pointer" }}
        flexShrink={0}
      >
        <Text
          w={"60%"}
          fontWeight={"bold"}
          color={"white"}
          fontSize={"clamp(11px, 0.8vw, 15px)"}
          lineHeight={"1.2"}
        >
          SIMULE UMA VENDA
        </Text>
      </Flex>
      <Img
        _hover={{ cursor: "pointer" }}
        onClick={() => setIsOpen(true)}
        h={"clamp(150px, 15vw, 240px)"}
        maxW={"100%"}
        objectFit={"contain"}
        src={maquininha}
        alt="Simule uma venda"
      />
    </Flex>
  );
}
